import { Component } from '../lib/ComponentBase';
import { registerComponent } from '../lib/ComponentHelpers';
import HexCoords from '../grid/HexCoords';

class Archetype extends Component {
  name: string;
  displayName: string;
  overrides: Record<string, any>;

  constructor(data: { name: string, displayName?: string, overrides?: Record<string, any> } = { name: '' }) {
    super();
    this.name = data.name;
    this.displayName = data.displayName ?? data.name;
    // Hydrate hexPosition.coords if present in overrides
    const overrides = { ...data.overrides };
    if (overrides.hexPosition?.coords) {
      overrides.hexPosition = {
        ...overrides.hexPosition,
        coords: HexCoords.get(overrides.hexPosition.coords),
      };
    }
    this.overrides = overrides;
  }

  equals(other: this): boolean {
    // Compare name
    if (this.name !== other.name) return false;

    // Validate that hexPosition.coords is properly hydrated if present
    if (this.overrides.hexPosition?.coords) {
      if (!(other.overrides.hexPosition?.coords instanceof HexCoords)) {
        console.error(`Archetype.equals: other.overrides.hexPosition.coords is not a HexCoords instance`, other.overrides.hexPosition?.coords);
        return false;
      }
    }

    // Compare overrides using JSON (sufficient for simple data structures)
    return JSON.stringify(this.toJSON().overrides) ===
           JSON.stringify(other.toJSON().overrides);
  }

  static getTestInstances(): Archetype[] {
    return [
      new Archetype({ name: 'TestArchetype' }),
      new Archetype({ name: 'WithOverrides', overrides: {
        hexPosition: { coords: { q: 0, r: 0 }, bearing: 1 },
      }}),
    ];
  }
}

export default registerComponent(Archetype);
